import { useState } from 'react';
import type { JSX } from 'react';

import { Spinner } from '@change/ds-core-ui';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PromotePagePrefetchedDataProps } from 'src/app/pages/promote/pageContext';
import { prefetchPageContext, PromotePageContextProvider } from 'src/app/pages/promote/pageContext';
import { StripeLoader } from 'src/app/shared/components/payments';
import { PaypalProvider } from 'src/app/shared/hooks/payments';
import { isLoaded } from 'src/app/shared/utils/async';

import { Layout } from '../layout';

import { ErrorHandler } from './ErrorHandler';

export const Promote = withPrefetchedData(
	({ prefetchedData }: PromotePagePrefetchedDataProps): JSX.Element => {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		const [loadingStartTime] = useState(() => performance.now());

		return (
			<StripeLoader>
				<PaypalProvider>
					<PromotePageContextProvider
						slug={slug}
						prefetchedData={prefetchedData}
						errorHandler={ErrorHandler}
						loadingFallback={<Spinner className="mx-auto my-64" />}
					>
						<Layout loadingStartTime={loadingStartTime} />
					</PromotePageContextProvider>
				</PaypalProvider>
			</StripeLoader>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			const data = await prefetchPageContext(context.params.slug!, context);
			return {
				...data,
				// FIXME this is a temporary way to provide the petitionId to the PX sensor for apps/front-end/src/app/createRoutes.tsx
				perimeterx:
					data.pageData && isLoaded(data.pageData)
						? {
								petitionId: data.pageData.pageData.petition.id,
							}
						: undefined,
			};
		},
	},
);
